import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.sftpsPage, action) => {
  switch (action.type) {
    case types.SET_SFTPS_PAGE:
      return action.sftpsPage;

    default:
      return state;
  }
};
